/*
 * File: Routes.js
 * Project: mp-mobile-app
 *
 * Created by Cole on 01/02/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */
import DashboardApp from "services/dashboard";
import PatientsApp from "services/patients/PatientsApp";
import PatientSearchApp from "services/patients/search/PatientSearchApp";
import ApptsApp from "services/appointments/ApptsApp";
import OrdersApp from "services/orders/OrdersApp";
import ReferralsApp from "services/referrals";
import PreferencesApp from "services/preferences";
import HelpApp from "services/help";
import DefaultRedirect from "components/DefaultRedirect";

const Routes = [
  {
    path: "/",
    exact: true,
    component: DefaultRedirect
  },
  {
    path: "/dashboard",
    exact: true,
    component: DashboardApp
  },
  {
    path: "/patients",
    exact: true,
    component: PatientSearchApp
  },
  {
    path: "/search",
    component: PatientSearchApp
  },
  {
    path: "/patients/:patientId",
    component: PatientsApp
  },
  {
    path: "/appointments",
    component: ApptsApp
  },
  {
    path: "/orders",
    component: OrdersApp
  },
  {
    path: "/referrals",
    component: ReferralsApp
  },
  {
    path: "/preferences",
    component: PreferencesApp
  },
  {
    path: "/help",
    component: HelpApp
  }
];

export default Routes;
